import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AuthService } from '@klickdata/core/auth';
import { MobileService } from '@klickdata/core/mobile';
import { ActivateComponent } from '@klickdata/guest/src/activate/activate.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { ChatIoPaymentComponent } from './chat-io/chat-io-payment/chat-io-payment.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { LoginComponent } from './login/login.component';
import { OnBoardingComponent } from './on-boarding/on-boarding.component';
import { SignupComponent } from './signup/signup.component';
import { MatDrawer } from '@angular/material/sidenav';
import { CustomerLanding } from '@klickdata/core/customer';
import { GuestService } from './guest.service';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';

@Component({
    selector: 'app-guest',
    templateUrl: 'guest.component.html',
    styleUrls: ['guest.component.scss'],
})
export class GuestComponent extends OnDestroyHandler implements OnInit {
    public isMobile: Observable<boolean>;
    onboarding: boolean;
    guestMode$: Observable<boolean>;
    showHeader = true;
    isHeaderWithOnlyLang: boolean;
    @ViewChild('drawer') drawer: MatDrawer;
    public accessModeSub: BehaviorSubject<'login' | 'signup'> = new BehaviorSubject<'login' | 'signup'>('login');
    public customerLanding$: Observable<CustomerLanding>;

    constructor(
        private title: Title,
        protected mobile: MobileService,
        protected changeRef: ChangeDetectorRef,
        protected guestService: GuestService,
        protected auth: AuthService
    ) {
        super();
        this.title.setTitle('KlickData');
    }
    ngOnInit() {
        this.isMobile = this.mobile.isMobile().pipe(
            map((res) => {
                this.changeRef.markForCheck();
                return res;
            })
        );
        this.customerLanding$ = this.auth.getCustomerLanding();
        this.guestMode$ = this.customerLanding$.pipe(map((landing) => landing.guest_mode));
        this.guestService
            .getDrawerStatus()
            .pipe(
                takeUntil(this.destroy),
                filter(() => !!this.drawer)
            )
            .subscribe((status) => {
                if (status) {
                    this.accessModeSub.next(this.guestService.getAccessMode());
                    this.drawer.open();
                } else {
                    this.drawer.close();
                }
                this.changeRef.markForCheck();
            });
    }
    onLoginOrSignup() {
        this.guestService.dismiss(true);
        this.drawer.close();
    }
    onDrawerClosed() {
        this.guestService.dismiss(null);
    }
    componentAdded(component: any) {
        this.onboarding = component instanceof OnBoardingComponent || component instanceof ForgetPasswordComponent;
        this.showHeader = !(component instanceof ChatIoPaymentComponent);

        this.isHeaderWithOnlyLang =
            component instanceof LoginComponent ||
            component instanceof SignupComponent ||
            component instanceof ActivateComponent;
    }
}
